module.exports = __webpack_public_path__ + "static/logo-black-6ad65ede04bf76febffe61d4be9a9587.svg";